import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface IProcessPaymentRequest {
  pin: string;
  amount: number;
  clientId: string;
  username: string;
  reference: string;
  customerAccountName: string;
}

interface IProcessPaymentResponse {
  status?: boolean;
  message?: string;
  data?: unknown;
  errorCode?: string;
  errors?: IApiResponseError[];
}

const initialState: IApiState<IProcessPaymentResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const processPaymentAsync = createAsyncThunk(
  'deposits/processPayment',
  async (values: IProcessPaymentRequest, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `BearerToken ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const accountNumberFromStorage = localStorage.getItem('accountNumber');

      const { data } = await api.post(
        'bet9ja/deposits/process-payment',
        { ...values, customerAccountNo: accountNumberFromStorage },
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IProcessPaymentResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const processPaymentSlice = createSlice({
  name: 'payment/process',
  initialState,
  reducers: {
    resetProcessPayment(state) {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(processPaymentAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(processPaymentAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IProcessPaymentResponse;
      })
      .addCase(processPaymentAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IProcessPaymentResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetProcessPayment } = processPaymentSlice.actions;

export default processPaymentSlice.reducer;
